export enum UsIsfShipmentTypeCode {
  // 01 Standard or regular filings
  // Shipment Type Code must = 01 when submitting an ISF-5 Submission Type
  STANDARD = 'STANDARD',
  // 03 Household Goods / Personal Effects (HHG / PE)
  HHG_PE = 'HHG_PE',
  // 11 INFORMAL
  INFORMAL = 'INFORMAL',
}
